// import { useFormik } from "formik";
// import CustomAlert from "@components/Shared/Alert/CustomAlert";
// import Select from "react-select";
// import { Card } from "@components/card/card";
// import { CardBody, Form } from "react-bootstrap";
// import { useTranslation } from "react-i18next";
// import Breadcrumb from "@components/Shared/Breadcrumb";
// import { useAppDispatch, useAppSelector } from "@store/hooks";
// import { addUpdateCostTransactions } from "@store/INV/Transactions/UpdateCost/InvUpdateCostSlice";
// import { useNavigate } from "react-router-dom";
// import { TreeSelect } from "antd";
// import Loading from "@components/Shared/Loader/Loading";
// import useGetSubinventoryList from "@hooks/INV/Inventories/useGetSubinventoryList";
// import useGetInventoryWithPermission from "@hooks/NTX/Organization/useGetInventoryWithPermission";
// // import useGetBranchOrgWithPermission from '@hooks/NTX/Organization/useGetBranchOrgWithPermission';
// import NeatixModal from "@components/Modal/NeatixModal";
// import { useState } from "react";
// import { getPersonId } from "@store/Login/authSelectors";
// import { AddIssueTransactionsSchema } from "../../../ValidationForm/validationSchema";
// import useGetTransactionTypesList from "@hooks/INV/TransactionTypes/useGetTransactionTypesList";
// import UpdateCostLines from "./UpdateCostLines";
// import useGetOperatingUnitWithPermission from "@hooks/NTX/Organization/useGetOperatingUnitWithPermission";

// const Add = () => {
//   const [showModal, setShowModal] = useState(true);
//   // const [inventory, setInventory] = useState<any>(null);

//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();
//   const Navigate = useNavigate();
//   const { InventoryOptions, loading: loading4 } =
//     useGetInventoryWithPermission();
//   const { loading: loading1, TreeSubInventoryData } = useGetSubinventoryList();

//   const {
//     OptionsTransactionTypes,
//     loading: loading5,
//     error,
//   } = useGetTransactionTypesList();

//   const {
//     OperatingUnitOptions,
//     loading: loading6,
//     error: error6,
//   } = useGetOperatingUnitWithPermission();

//   const personId = useAppSelector(getPersonId);

//   //#region Formik
//   const formik = useFormik({
//     initialValues: {
//       code: "AVC", // تحديث سعـــر التكلــفة
//       transactionDate: "",
//       description: "",
//       branchId: "",
//       transactionAmount: 0,
//       referenceType: "",
//       referenceId: "",
//       supplierId: null,
//       customerId: null,
//       personId: personId,
//       subInventoryId: null,
//       inventoryId: "",
//       address: "",
//       note: "",
//       transactionYear: 0,
//       materialTransactionsLineList: [
//         {
//           id: null, //
//           transactionItemId: null,
//           transactionUom: "",
//           unitPrice: 0,
//           transactionQuantityIn: 0,
//           transactionQuantityOut: 0,

//           lotId: "",
//           // inventoryId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
//           // discount: 0,
//           // codeCombinationId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
//           // currencyCode: 'string',
//           // currencyConversionRate: 0,
//           referenceIdMaster: "",
//           referenceIdLine: "",
//           // transactionTypeId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
//           // equivalent: 0,
//           // expensesAmount: 0,
//           // batchId: '3fa85f64-5717-4562-b3fc-2c963f66afa6',
//         },
//       ],
//     },
//     enableReinitialize: true,
//     // validationSchema: AddIssueTransactionsSchema(t),
//     onSubmit: (values) => {
//       dispatch(
//         addUpdateCostTransactions({
//           code: values.code,
//           transactionDate: values.transactionDate,
//           description: values.description,
//           branchId: values.branchId,
//           transactionAmount: 0,
//           referenceType: values.code,
//           referenceId: values.referenceId || null,
//           supplierId: values.supplierId || null,
//           customerId: values.customerId || null,
//           personId: values.personId || null,
//           inventoryId: values.inventoryId,
//           address: values.address,
//           note: values.note,
//           transactionYear: 0,
//           subInventoryId: values.subInventoryId,
//           materialTransactionsLineList:
//             formik.values.materialTransactionsLineList?.map((item) => ({
//               transactionItemId: item.transactionItemId,
//               transactionUom: item.transactionUom,
//               unitPrice: item.unitPrice, // item.price
//               // unitPrice: 0, // item.price
//               transactionQuantityIn: item.transactionQuantityIn,
//               transactionQuantityOut: 0,
//               lotId: item.lotId || null,
//               inventoryId: null,
//               referenceIdMaster: null,
//               referenceIdLine: null,
//               transactionTypeId: null,
//               equivalent: 0,
//               expensesAmount: 0,
//             })),
//         })
//       )
//         .unwrap()
//         .then((res: any) => {
//           // debugger;
//           if (res?.succeeded === true) {
//             CustomAlert({ action: "Add" });
//             formik.resetForm();
//           } else {
//             formik.setSubmitting(false);
//             CustomAlert({ action: "Error", msg: res?.message });
//           }
//         })
//         .catch((error: any) => {
//           formik.setSubmitting(false);
//           CustomAlert({ action: "Error" });
//         });
//     },
//   });

//   const { values, handleChange: formikhandleChange, errors, touched } = formik;
//   //#endregion

//   console.log(values);

//   //____________________________
//   const BcrumbList = [
//     {
//       name: "Home",
//       link: ":moduleHome",
//     },
//     {
//       name: "Update Cost",
//       link: "/INV/Transactions/UpdateCost",
//     },
//     {
//       name: "Add Update Cost",
//       link: null,
//     },
//   ];

//   return (
//     <>
//       <Breadcrumb
//         BreadcrumbList={BcrumbList}
//         PageName="Update Cost"
//         subtitle={
//           InventoryOptions?.find((f: any) => f.value === values.inventoryId)
//             ?.label
//         }
//       />

//       <Card>
//         <Loading
//           loading={loading6 || loading4 || loading5 || loading1}
//           error={error}
//         >
//           <CardBody>
//             <Form onSubmit={formik.handleSubmit}>
//               <div className="row ">
//                 <div className="col-lg-3">
//                   <div className="form-group mb-3">
//                     <label className="form-label">{t("التاريـخ")}</label>
//                     <Form.Control
//                       className="form-control  text-center"
//                       type="date"
//                       name="transactionDate"
//                       onChange={formikhandleChange}
//                       value={values.transactionDate || ""}
//                       // isInvalid={!!(touched.transactionDate && errors.transactionDate)}
//                     />
//                     <div className="text-danger small">
//                       {formik.touched.transactionDate &&
//                         formik.errors.transactionDate}
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-lg-3">
//                   <div className="form-group mb-3">
//                     <label className="form-label">
//                       {t("الوحدة التشغيليـة")}
//                     </label>
//                     <Select
//                       isDisabled
//                       classNamePrefix="react-select"
//                       isLoading={loading6}
//                       isSearchable
//                       isClearable
//                       options={OperatingUnitOptions}
//                       value={OperatingUnitOptions?.find(
//                         (f: any) => f.value === formik.values.branchId
//                       )}
//                       // onChange={(option) => {
//                       //   formik.setFieldValue('inventoryId', '');
//                       //   formik.setFieldValue('branchId', option?.value || '');
//                       // }}
//                       placeholder={i18n.language === "ar" ? "إختر" : "Choose"}
//                     />
//                   </div>
//                 </div>

//                 <div className="col-lg-3">
//                   <div className="form-group mb-3">
//                     <label className="form-label">{t("المخزن")}</label>
//                     <Select
//                       isDisabled
//                       classNamePrefix="react-select"
//                       isLoading={loading4}
//                       isSearchable={true}
//                       isClearable
//                       options={InventoryOptions}
//                       value={InventoryOptions?.find(
//                         (f: any) => f.value === values.inventoryId
//                       )}
//                       // onChange={(option: any) => {
//                       //   formik.setFieldValue('inventoryId', option === null ? null : option.value);
//                       //   // formik.setFieldValue('subInventoryId', null);
//                       // }}
//                       placeholder={i18n.language === "ar" ? "إختر" : "Choose"}
//                     />
//                     <div className="text-danger small">
//                       {formik.touched.inventoryId && formik.errors.inventoryId}
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-lg-3">
//                   <div className="form-group mb-3">
//                     <label className="form-label">{t("المخزن الفرعي")}</label>
//                     <TreeSelect
//                       showSearch
//                       className="w-100"
//                       treeLine
//                       placeholder={i18n.language === "ar" ? "إختر" : "Choose"}
//                       allowClear
//                       treeDefaultExpandAll={false}
//                       value={values.subInventoryId}
//                       onChange={(option: any) => {
//                         formik.setFieldValue(
//                           "subInventoryId",
//                           option === null ? null : option
//                         );
//                       }}
//                       treeData={TreeSubInventoryData?.filter(
//                         (f) => f.parentId === values.inventoryId
//                       )}
//                       treeNodeFilterProp="title"
//                     />
//                     <div className="text-danger small">
//                       {formik.touched.subInventoryId &&
//                         formik.errors.subInventoryId}
//                     </div>
//                   </div>
//                 </div>
//                 <div className="col-lg-3">
//                   <div className="form-group mb-3">
//                     <label className="form-label">{t("نوع الحركة")}</label>
//                     <Select
//                       isDisabled
//                       classNamePrefix="react-select"
//                       // isLoading={loading3}
//                       isSearchable={true}
//                       isClearable
//                       options={OptionsTransactionTypes}
//                       value={OptionsTransactionTypes.find(
//                         (f) => f.value === values.code
//                       )}
//                       onChange={(option: any) => {
//                         formik.setFieldValue(
//                           "code",
//                           option === null ? null : option.value
//                         );
//                       }}
//                       placeholder={i18n.language === "ar" ? "إختر" : "Choose"}
//                     />
//                     <div className="text-danger small">
//                       {formik.touched.code && formik.errors.code}
//                     </div>
//                   </div>
//                 </div>

//                 {/* <div className="col-lg-3">
//                   <div className="form-group mb-3">
//                     <label className="form-label">{t('personId - store keeper')}</label>
//                     <Select
//                       isDisabled
//                       classNamePrefix="react-select"
//                       isLoading={loading}
//                       isSearchable={true}
//                       isClearable
//                       name="personId"
//                       options={dataEmployees}
//                       value={dataEmployees?.find((f: any) => f.value === values.personId)}
//                       onChange={(option: any) => {
//                         formik.setFieldValue('personId', option === null ? null : option.value);
//                       }}
//                       placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                     />
//                   </div>
//                 </div> */}

//                 <div className="col-lg-9">
//                   <div className="form-group mb-3">
//                     <label className="form-label">{t("Note")}</label>
//                     <Form.Control
//                       autoComplete="off"
//                       className="form-control"
//                       as="textarea"
//                       rows={1}
//                       name="description"
//                       onChange={formik.handleChange}
//                       value={values.description}
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div className="row m-0 p-0">
//                 {values.inventoryId && (
//                   <div className="bg-inverse bg-opacity-5 p-2 position-relative">
//                     <UpdateCostLines formik={formik} />
//                   </div>
//                 )}
//               </div>

//               <div className="text-center mt-4">
//                 <button
//                   disabled={formik.isSubmitting}
//                   type="submit"
//                   className="btn btn-lg me-1 btn-theme mb-1"
//                 >
//                   {formik.isSubmitting ? (
//                     <div className="spinner-border spinner-border-sm me-2"></div>
//                   ) : (
//                     <i className="fas fa-lg fa-fw me-2 fa-plus"></i>
//                   )}
//                   {t("Add")}
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-lg  me-1 btn-default mb-1"
//                   onClick={() => Navigate(-1)}
//                 >
//                   <i className="fa fa-power-off fa-fw me-1"></i> {t("Cancel")}
//                 </button>
//               </div>
//             </Form>
//           </CardBody>
//         </Loading>
//       </Card>

//       <NeatixModal
//         show={showModal}
//         setShow={setShowModal}
//         size="md"
//         bodyClassName="p-0"
//         showHeader={false}
//         keyboard={false}
//         backdrop={true}
//       >
//         <Card>
//           <CardBody>
//             <div className="row">
//               {/* Operating Unit Selection */}
//               <div className="col-lg-12">
//                 <div className="form-group mb-3">
//                   <label className="form-label">{t("الوحدة التشغيليـة")}</label>
//                   <Select
//                     classNamePrefix="react-select"
//                     isLoading={loading6}
//                     isSearchable
//                     isClearable
//                     options={OperatingUnitOptions}
//                     value={OperatingUnitOptions?.find(
//                       (f: any) => f.value === formik.values.branchId
//                     )}
//                     onChange={(option) => {
//                       formik.setFieldValue("inventoryId", "");
//                       formik.setFieldValue("branchId", option?.value || "");
//                     }}
//                     placeholder={i18n.language === "ar" ? "إختر" : "Choose"}
//                   />
//                 </div>
//               </div>

//               {/* Inventory Selection */}

//               <div className="col-lg-12">
//                 <div className="form-group mb-3">
//                   <label className="form-label">{t("المخزن")}</label>
//                   <Select
//                     classNamePrefix="react-select"
//                     isLoading={loading4}
//                     isSearchable
//                     isClearable
//                     options={InventoryOptions?.filter(
//                       (f: any) => f.operatingUnitId === formik.values.branchId
//                     )}
//                     value={
//                       formik.values.inventoryId &&
//                       InventoryOptions?.find(
//                         (f: any) => f.value === formik.values.inventoryId
//                       )
//                     }
//                     onChange={(option) =>
//                       formik.setFieldValue("inventoryId", option?.value || null)
//                     }
//                     placeholder={i18n.language === "ar" ? "إختر" : "Choose"}
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="row">
//               <div className="col-6">
//                 <button
//                   type="button"
//                   className="btn btn-lg btn-theme  w-100 rounded-0"
//                   // onClick={handleSubmitModal}
//                   onClick={() => setShowModal(false)}
//                   disabled={
//                     !formik.values.branchId || !formik.values.inventoryId
//                   }
//                 >
//                   <i className="fas fa-lg fa-fw me-2 fa-check-circle"></i>
//                   {t("إختيار")}
//                 </button>
//               </div>
//               <div className="col-6">
//                 <button
//                   type="button"
//                   className="btn btn-lg  btn-default  w-100 rounded-0"
//                   onClick={() =>
//                     Navigate("/INV/Transactions/UpdateCost", { replace: true })
//                   }
//                 >
//                   <i className="fas fa-times-circle fa-fw me-1"></i>{" "}
//                   {t("Cancel")}
//                 </button>
//               </div>
//             </div>
//           </CardBody>
//         </Card>
//       </NeatixModal>
//     </>
//   );
// };

// export default Add;


import { useFormik } from 'formik';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import Select from 'react-select';
import { Card } from '@components/card/card';
import { CardBody, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { addUpdateCostTransactions } from '@store/INV/Transactions/UpdateCost/InvUpdateCostSlice';
import { useNavigate } from 'react-router-dom';
import { TreeSelect } from 'antd';
import Loading from '@components/Shared/Loader/Loading';
import useGetSubinventoryList from '@hooks/INV/Inventories/useGetSubinventoryList';
import useGetInventoryWithPermission from '@hooks/NTX/Organization/useGetInventoryWithPermission';
import NeatixModal from '@components/Modal/NeatixModal';
import { useEffect, useMemo, useState } from 'react';
import { getPersonId } from '@store/Login/authSelectors';
import UpdateCostLines from './UpdateCostLines';
import useGetOperatingUnitWithPermission from '@hooks/NTX/Organization/useGetOperatingUnitWithPermission';

const Add = () => {
  const [showModal, setShowModal] = useState(true);

  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { OperatingUnitOptions, loading: loadingOU, error: errorOU } = useGetOperatingUnitWithPermission();
  const { InventoryOptions, loading: loadingInv, error: errorInv } = useGetInventoryWithPermission();
  const { TreeSubInventoryData, loading: loadingSub, error: errorSub } = useGetSubinventoryList();

  const personId = useAppSelector(getPersonId);

  const FIXED_CODE = 'AVC';

  const emptyLine = {
    id: null,
    transactionItemId: null,
    transactionUom: '',
    unitPrice: 0,
    transactionQuantityIn: 0,
    transactionQuantityOut: 0,
    lotId: null as any,
    referenceIdMaster: '',
    referenceIdLine: '',
    total: 0
  };

  const formik = useFormik({
    initialValues: {
      code: FIXED_CODE,
      transactionDate: new Date().toISOString().split('T')[0],
      description: '',
      branchId: '',
      transactionAmount: 0,

      // ✅ لا يوجد مرجع
      referenceType: FIXED_CODE,
      referenceId: null as any,
      referenceCode: '',

      supplierId: null as any,
      customerId: null as any,
      personId: personId ?? null,

      subInventoryId: null as any,
      inventoryId: '',

      address: '',
      note: '',
      transactionYear: 0,

      materialTransactionsLineList: [emptyLine]
    },
    enableReinitialize: true,
    onSubmit: values => {
      const lines = (values.materialTransactionsLineList || []).filter(
        (l: any) => l?.transactionItemId && n(l?.transactionQuantityIn) !== 0
      );

      if (lines.length === 0) {
        CustomAlert({ action: 'info', msg: 'لا يوجد أصناف' });
        formik.setSubmitting(false);
        return;
      }

      dispatch(
        addUpdateCostTransactions({
          code: values.code,
          transactionDate: values.transactionDate,
          description: values.description,
          branchId: values.branchId,
          transactionAmount: 0,

          // ✅ بدون مرجع
          referenceType: values.code,
          referenceId: null,
          supplierId: null,
          customerId: null,

          personId: values.personId || null,
          inventoryId: values.inventoryId,
          address: values.address,
          note: values.note,
          transactionYear: 0,
          subInventoryId: values.subInventoryId,

          materialTransactionsLineList: (values.materialTransactionsLineList || []).map((item: any) => ({
            transactionItemId: item.transactionItemId,
            transactionUom: item.transactionUom,
            unitPrice: n(item.unitPrice),
            transactionQuantityIn: n(item.transactionQuantityIn),
            transactionQuantityOut: 0,
            lotId: item.lotId || null,

            inventoryId: null,
            referenceIdMaster: null,
            referenceIdLine: null,
            transactionTypeId: null,
            equivalent: 0,
            expensesAmount: 0
          }))
        })
      )
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Add' });
            navigate(-1 as any, { replace: true });
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch(() => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  const { values, handleChange: formikhandleChange, errors, touched } = formik;

  const isLoading = useMemo(
    () => loadingOU || loadingInv || loadingSub,
    [loadingOU, loadingInv, loadingSub]
  );

  const isError = useMemo(
    () => errorOU || errorInv || errorSub,
    [errorOU, errorInv, errorSub]
  );

  // ✅ فلترة المخازن حسب الوحدة التشغيلية
  const inventoryOptionsFiltered = useMemo(() => {
    if (!formik.values.branchId) return [];
    return (InventoryOptions || []).filter((x: any) => x.operatingUnitId === formik.values.branchId);
  }, [InventoryOptions, formik.values.branchId]);

  // ✅ تحديد المخزن الفرعي الأول تلقائياً
  useEffect(() => {
    if (values.inventoryId && TreeSubInventoryData?.length > 0) {
      const filtered = TreeSubInventoryData.filter((f: any) => f.parentId === values.inventoryId);
      if (!values.subInventoryId && filtered.length > 0) {
        formik.setFieldValue('subInventoryId', filtered[0].value);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.inventoryId, TreeSubInventoryData]);

  const selectedOU = OperatingUnitOptions?.find((x: any) => x.value === values.branchId);
  const selectedInv = InventoryOptions?.find((x: any) => x.value === values.inventoryId);

  const BcrumbList = [
    { name: t('Home'), link: ':moduleHome' },
    { name: t('Update Cost'), link: '/INV/Transactions/UpdateCost' },
    { name: t('Add Update Cost'), link: null }
  ];

  const canConfirm = !!formik.values.branchId && !!formik.values.inventoryId;

  return (
    <>
      <Breadcrumb
        BreadcrumbList={BcrumbList}
        PageName={t('Update Cost')}
        subtitle={selectedInv?.label}
      />

      {/* ✅ لا تظهر الشاشة إلا بعد اختيار OU + Inventory */}
      {!showModal && (
        <Form onSubmit={formik.handleSubmit}>
          <Loading loading={isLoading} error={isError}>
            <Card>
              <CardBody>
                {/* ✅ ملخص */}
                <Card className='mb-3 border-0 bg-theme bg-opacity-10'>
                  <div className='p-3 d-flex flex-wrap gap-4 align-items-center justify-content-between'>
                    <div>
                      <div className='small text-muted'>{t('OperatingUnit')}</div>
                      <div className='fw-bold'>{selectedOU?.label ?? '-'}</div>
                    </div>
                    <div>
                      <div className='small text-muted'>{t('Inventory')}</div>
                      <div className='fw-bold'>{selectedInv?.label ?? '-'}</div>
                    </div>
                    <div>
                      <div className='small text-muted'>{t('TransactionType')}</div>
                      <div className='fw-bold'>{FIXED_CODE}</div>
                    </div>
                  </div>
                </Card>

                <div className='row'>
                  <div className='col-lg-3'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('Date')}</label>
                      <Form.Control
                        className='form-control text-center'
                        type='date'
                        name='transactionDate'
                        onChange={formikhandleChange}
                        value={values.transactionDate || ''}
                      />
                      <div className='text-danger small'>
                        {touched.transactionDate && (errors.transactionDate as any)}
                      </div>
                    </div>
                  </div>

                  <div className='col-lg-3'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('SubInventory')}</label>
                      <TreeSelect
                        loading={loadingSub}
                        showSearch
                        className='w-100'
                        treeLine
                        placeholder={t('Choose')}
                        allowClear
                        treeDefaultExpandAll={false}
                        value={values.subInventoryId}
                        onChange={(option: any) => formik.setFieldValue('subInventoryId', option === null ? null : option)}
                        treeData={TreeSubInventoryData?.filter((f: any) => f.parentId === values.inventoryId)}
                        treeNodeFilterProp='title'
                      />
                      <div className='text-danger small'>
                        {touched.subInventoryId && (errors.subInventoryId as any)}
                      </div>
                    </div>
                  </div>

                  <div className='col-lg-6'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('Note')}</label>
                      <Form.Control
                        autoComplete='off'
                        className='form-control'
                        as='textarea'
                        rows={1}
                        name='description'
                        onChange={formik.handleChange}
                        value={values.description}
                      />
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Loading>

          <Card className='pt-1 mt-2 shadow-sm'>
            {values.inventoryId && <UpdateCostLines formik={formik} />}
          </Card>

          <Card className='p-2 mt-2'>
            <div className='text-end'>
              <button disabled={formik.isSubmitting} type='submit' className='btn btn-lg me-1 btn-theme rounded'>
                {formik.isSubmitting ? (
                  <div className='spinner-border spinner-border-sm me-2'></div>
                ) : (
                  <i className='fas fa-lg fa-fw me-2 fa-plus'></i>
                )}
                {t('Add')}
              </button>

              <button type='button' className='btn btn-lg me-1 btn-default rounded' onClick={() => navigate(-1)}>
                <i className='fa fa-power-off fa-fw me-1'></i> {t('Cancel')}
              </button>
            </div>
          </Card>
        </Form>
      )}

      {/* ✅ مودال بسيط: اختيار OU + Inventory فقط */}
      <NeatixModal
        show={showModal}
        setShow={(v: boolean) => setShowModal(v)}
        size='md'
        bodyClassName='p-0'
        showHeader={false}
        keyboard={false}
        backdrop={true}
        centered
      >
        <Card className='border-0 m-0 p-0'>
          <CardBody>
            <div className='mb-3 fw-bold'>
              <i className='fas fa-coins me-2'></i>
              {i18n.language === 'ar' ? 'اختيار الوحدة التشغيلية والمخزن' : 'Choose OU & Inventory'}
            </div>

            

            <div className='row'>
              <div className='col-12'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('الوحدة التشغيليـة')}</label>
                  <Select
                    classNamePrefix='react-select'
                    isLoading={loadingOU}
                    isSearchable
                    isClearable
                    options={OperatingUnitOptions}
                    value={OperatingUnitOptions?.find((f: any) => f.value === formik.values.branchId) ?? null}
                    onChange={(opt: any) => {
                      formik.setFieldValue('branchId', opt?.value || '');
                      formik.setFieldValue('inventoryId', '');
                      formik.setFieldValue('subInventoryId', null);
                    }}
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                  />
                </div>
              </div>

              <div className='col-12'>
                <div className='form-group mb-3'>
                  <label className='form-label'>{t('المخزن')}</label>
                  <Select
                    classNamePrefix='react-select'
                    isLoading={loadingInv}
                    isSearchable
                    isClearable
                    options={inventoryOptionsFiltered}
                    value={InventoryOptions?.find((f: any) => f.value === formik.values.inventoryId) ?? null}
                    onChange={(opt: any) => {
                      formik.setFieldValue('inventoryId', opt?.value || '');
                      formik.setFieldValue('subInventoryId', null);
                    }}
                    placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                    isDisabled={!formik.values.branchId}
                  />
                </div>
              </div>
            </div>

            <div className='row g-2'>
              <div className='col-6'>
                <button
                  type='button'
                  className='btn btn-lg btn-theme w-100 rounded-0'
                  onClick={() => {
                    // ✅ تجهيز الفورم عند الإختيار
                    formik.setFieldValue('code', FIXED_CODE);
                    formik.setFieldValue('referenceType', FIXED_CODE);
                    formik.setFieldValue('referenceId', null);
                    formik.setFieldValue('materialTransactionsLineList', [emptyLine]);
                    setShowModal(false);
                  }}
                  disabled={!canConfirm}
                >
                  <i className='fas fa-lg fa-fw me-2 fa-check-circle'></i>
                  {t('إختيار')}
                </button>
              </div>

              <div className='col-6'>
                <button
                  type='button'
                  className='btn btn-lg btn-default w-100 rounded-0'
                  onClick={() => navigate('/INV/Transactions/UpdateCost', { replace: true })}
                >
                  <i className='fas fa-times-circle fa-fw me-1'></i> {t('Cancel')}
                </button>
              </div>
            </div>
          </CardBody>
        </Card>
      </NeatixModal>
    </>
  );
};

export default Add;

function n(v: any) {
  const x = Number(v);
  return Number.isFinite(x) ? x : 0;
}
